export default __webpack_public_path__ + "static/media/WhiteCourses.2470f38c.svg";